import { Button, Input } from 'antd';
import React, { Component } from 'react'
import { UndoOutlined } from '@ant-design/icons';
import FileDownload from '../FileDownload';
import FilterHoc from '../../workflow/operations/filters/FilterHOC';

export default class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue:""
        }
   
    }

    search = value => {
        const { dataNew } = this.props;
        const filterTable2 = dataNew.filter(o =>
          Object.keys(o).some(k =>
            String(o[k])
              .toLowerCase()
              .includes(value.toLowerCase())
          )
        );
          this.setState({ searchValue: value });
        this.props.filterSearchData(filterTable2,value)
      };

      clearFilter = () =>{
        const { dataNew } = this.props;
          this.setState({ searchValue: "" });
        this.props.filterSearchData(dataNew, null)
      }

       handleChange = e => {
    this.setState({ searchValue: e.target.value });
  }


  render() {
     const { searchValue } = this.state;
    const {allowDownloadAsPdf,operation,isReadOneTable,allDataDownload,allData,allRows,rows,columns,fileName,dateformat,workflow} = this.props
    if(this.props.filterTemplateCompany === 'TEMPLATE_FOUR' ){
      return (
        <div className='filter-new-template filter-new-template-2'>
          <div className='input'>
        <Input.Search
        placeholder="Search by ID, name, or others..."
        enterButton
        onSearch={this.search.bind(this)}
        value={searchValue}
         onChange={this.handleChange} 
      />
      </div>
      <Button className='button'  onClick={this.clearFilter.bind(this)}>
      <UndoOutlined /> 
      Clear
      </Button>
      <div>
      {(allowDownloadAsPdf && operation == 'READALL') || isReadOneTable ? <div className='mb-3' style={{  marginLeft:10}}>
                                <FileDownload rows={allDataDownload && allData.length > 0 ? allRows : rows} columns={columns} name={fileName} dateformat={dateformat} fromReadAll={true} duplicateRowsForOneToMany={workflow.currentItem.layoutProperties.duplicateRowsInOneToMany} companyDetails={this.props.companyDetails && this.props.companyDetails.data ? this.props.companyDetails.data :null  } /></div> : null}

      </div>
      <div  style={{marginLeft:10}}>
      <FilterHoc filterFromTemplate={true} {...this.props}/>
      </div>
      </div>
    )
    }
    return (
        <div className='filter-new-template'>
          <div className='input'>
        <Input.Search
        placeholder="Search by..."
        enterButton
        onSearch={this.search.bind(this)}
      />
      </div>
      <Button className='button'  onClick={this.clearFilter.bind(this)}>
      <UndoOutlined /> 
      Clear
      </Button>
      </div>
    )
  }
}
